/**
 * Field formatters and display labels for the Asset List change-history feed.
 *
 * Used by: `AssetPanel.tsx` -> `<ChangeHistory />`.
 */

import { ASSET_TYPE_LABEL } from "../constants";

const ASSET_STATUS_LABELS: Record<string, string> = {
  in_possession: "In possession",
  recovered: "Recovered",
  excluded: "Excluded",
  uncertain: "Uncertain",
  out_of_pos_third_party: "Held by third party",
};

const ASSET_PHASE_LABELS: Record<string, string> = {
  pre_appointment: "Pre-appointment",
  post_appointment: "Post-appointment",
};

export const ASSET_FIELD_FORMATTERS: Record<
  string,
  (value: unknown) => string
> = {
  description: (v) => String(v ?? "\u2014"),
  notes: (v) => String(v ?? "\u2014"),
  location: (v) => String(v ?? "\u2014"),
  assetType: (v) => ASSET_TYPE_LABEL[String(v)] ?? String(v ?? "\u2014"),
  assetStatus: (v) => ASSET_STATUS_LABELS[String(v)] ?? String(v ?? "\u2014"),
  assetPhase: (v) => ASSET_PHASE_LABELS[String(v)] ?? String(v ?? "\u2014"),
  subjectToSecurityInterest: (v) => (v ? "Yes" : "No"),
};

export const ASSET_FIELD_LABELS: Record<string, string> = {
  description: "Description",
  assetType: "Asset type",
  assetStatus: "Status",
  assetPhase: "Phase",
  subjectToSecurityInterest: "Secured",
  location: "Location",
  notes: "Notes",
};
